import { COUNTRY_CODES } from 'chat-util/countryCodes.js';
import { T, t } from '@jsx6/jsx6';

export const phoneInput = (item, toggleSubmit, chat) => {
  let selectedCountry = null;
  let lang = chat.options?.lang;
  if (!lang || lang === 'en') {
    const { locale, timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const timeZoneToLang = {
      "Europe/Zagreb": "hr",
      "Europe/Belgrade": "sr",
      "Europe/Tirane": "sq",
      "Europe/Ljubljana": "sl",
      "Europe/Skopje": "mk",
      "Europe/Sarajevo": "bs",
      "Europe/Pristina": "sq",
      "Europe/Podgorica": "cnr"
    };
    lang = timeZoneToLang[timeZone] || locale.split("-")[0] || "en";
  }

  let input = (
    <div class="form-line">
      <input
        id="phone-input"
        placeholder={T`placeholder_telephone`}
        data-item-id={item.id}
        type={item.type}
        data-store-into={item.storeInto}
        required={item.mandatory}
      />
      <div class="error-message" hidden>
        {t`required_message`}
      </div>
    </div>
  );

  const phoneInputField = input.querySelector("#phone-input");
  
  phoneInputField.addEventListener("input", () => {
    phoneInputField.value = phoneInputField.value.replace(/[^\d+]/g, "");
  });

  phoneInputField.addEventListener("keyup", toggleSubmit);

  return input;
};